import { geminiService } from './geminiService';

/**
 * API Service that handles all interaction with backend services
 */
class ApiService {
  /**
   * Extract questions from multiple images
   * @param {Array} images - Array of image files
   * @returns {Promise<Array>} - Array of extracted questions
   */
  async extractQuestions(images) {
    let allQuestions = [];
    for (const image of images) {
      try {
        const questions = await geminiService.extractQuestionsFromImage(image);
        allQuestions = [...allQuestions, ...questions];
      } catch (error) {
        console.error(`Error extracting questions from image ${image.name}:`, error);
        // Continue processing other images even if one fails
      }
    }
    
    return allQuestions;
  }
  
  /**
   * Generate solution for a specific question
   * @param {Object} question - Question object
   * @returns {Promise<Object>} - Generated solution object with solution text and correct answer
   */
  async generateSolution(question) {
    return geminiService.generateSolution(question);
  }
  
  /**
   * Generate solutions for multiple questions
   * @param {Array} questions - Array of question objects
   * @returns {Promise<Array>} - Array of solution objects with questionId, solution, and correctAnswer properties
   */
  async generateSolutions(questions) {
    return geminiService.generateSolutions(questions);
  }
  
  /**
   * Set API mode (for future use if needed)
   * @param {boolean} useMock - Not used currently
   */
  setMockMode(useMock) {
    // Keeping this method for compatibility, but it does nothing now
    console.log("Mock mode is no longer supported");
  }
}

// Export a singleton instance
export const apiService = new ApiService();